export function joinWithAnd(items: string[]): string {
    if (items.length <= 1) {
        return items[0] ?? "";
    }
    if (items.length === 2) {
        return `${items[0]} and ${items[1]}`;
    }
    return `${items.slice(0, -1).join(", ")}, and ${items.at(-1)}`;
}
